import { useDocument } from '@nandorojo/swr-firestore';
import { CollectionPath } from '@typings/collections.enum';
import { ImemberTitle } from '@typings/setting/memberTitle.interface';
import React from 'react';
import styled from 'styled-components';
import { replaceContents } from '@utils/replaceContents';

const TitleText = styled.span<{ $textColor?: string; $bgColor?: string }>`
  font-size: 12px;
  color: ${({ $textColor }) => $textColor || 'var(--primaryColor)'};
  background: ${({ $bgColor }) => $bgColor || 'var(--inkColor)'};
  padding: 2px 6px;
  border-radius: 4px;
  font-weight: 500;
  white-space: nowrap;
`;

const TitleImage = styled.img`
  max-height: 20px;
  object-fit: contain;
`;

type Props = {
  titleID?: string;
  style?: React.CSSProperties;
};

function UserTitle({ titleID, style }: Props) {
  const { data } = useDocument<ImemberTitle>(
    `${CollectionPath.MEMBERTITLE}/${titleID}`,
    { listen: true },
  );

  if (!titleID || !data?.exists) return null;

  // titleType이 'text'이거나, 이미지가 없고 displayText가 있는 경우 텍스트 표시
  const shouldShowText =
    data?.titleType === 'text' || (!data?.imgURL && data?.displayText);

  if (shouldShowText) {
    const text = data?.displayText || data?.title;
    if (!text) return null;
    return (
      <TitleText
        $textColor={data?.textColor}
        $bgColor={data?.bgColor}
        style={style}
        dangerouslySetInnerHTML={{ __html: replaceContents(text) }}
      ></TitleText>
    );
  }

  // 이미지 타입이고 imgURL이 있는 경우
  if (data?.imgURL) {
    return <TitleImage src={data.imgURL} alt={data?.title} style={style} />;
  }

  return null;
}

export default React.memo(UserTitle);
